import { render } from "./IndexType.vue?vue&type=template&id=c1512116"
import script from "./IndexType.vue?vue&type=script&lang=js"
export * from "./IndexType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__